import React from 'react';
import ProductStatusBadge from '../../../product/components/product-status-badge';
import StockIndicatorDiscontinued from './stock-indicator-discontinued';

import withPageComponents from '../../../page/components/with-page-components';
import { getShippingMessage } from '../../../product/get-product-props/cart';
import { useGetProductPrice } from '../../../hooks/useProductPrice';

const StockIndicator = ({ stockIndicatorProps, productInitial, showFor, device, shipDate, pdpSpecialOffers }) => {
    const { carepacktype, eol, product_type: productType, discontinuedMsg } = productInitial || {};
    const priceObj = useGetProductPrice(productInitial);

    if (!productInitial) return null;

    if (showFor && !showFor.includes(device)) {
        return null;
    }

    if (discontinuedMsg) {
        return <StockIndicatorDiscontinued message={discontinuedMsg} />;
    }

    const { subTitle } =
        productType && typeof productType === 'string' && productType.toLowerCase() === 'sto'
            ? getShippingMessage(productInitial, priceObj, pdpSpecialOffers)?.shippingMessage || {}
            : {};
    const hasDeliveryMessage = !!(subTitle && subTitle.label);

    return (
        carepacktype !== 'Electronic' &&
        !eol &&
        productType !== 'CTO' && (
            <ProductStatusBadge
                product={productInitial}
                displayShipMessage={true}
                showPreOrderMsg={true}
                stockIndicatorProps={stockIndicatorProps}
                shipDate={shipDate}
                hasDeliveryLabel={hasDeliveryMessage}
            />
        )
    );
};

export default withPageComponents(StockIndicator, {
    components: ['productInitial', 'pdpSpecialOffers'],
    device: true,
});
